import React from 'react'

const ColorPicker = ({myImage, myColor, changeColor, colors}) => {
  const [isOpen, setOpen] = React.useState(true)
  const loadedColors = Object.entries(colors).filter((a) => {
    return a[1].src
  })

  const radius = 200; // Should be same as in css
  const padding = 20;
  const amount = loadedColors.length
  const positions = loadedColors.map((i, index) => {
    var angle = ((index / amount) * 360 + 180) * -1;
    return {
      x: ((radius/2-padding*2) * Math.sin(Math.PI * 2 * angle / 360)),
      y: ((radius/2-padding*2) * Math.cos(Math.PI * 2 * angle / 360)),
    }
  })

  const onMouseEnter = () => {
    setOpen(true)
  }

  const onMouseLeave = () => {
    setOpen(false)
  }

  return (
    <div
      className={`ColorPicker ${isOpen ? 'open' : 'closed'}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <div className="ColorPickerBg"></div>
      <div className="placeholder">
        {myImage && myImage.src && <img alt="brush" src={myImage.src} />}
      </div>
      {loadedColors.map((item, index) => {
        const key = item[0]
        const color = item[1]
        const style = {
          left: `${positions[index].x + radius/2 - padding}px`,
          top: `${positions[index].y + radius/2 - padding}px`,
          transitionDelay: !isOpen ? '0s' : `${0.2+0.1*index}s`
        }
        return (
          <div
            style={style}
            key={key}
            onClick={() => {changeColor(key)}}
            className={`${myColor === key ? 'selected' : ''} colorHolder`}>
            <img alt={key} src={color.src} />
          </div>
        )
      })}
    </div>
  )
}

export default ColorPicker
